<!-- 字符验证码 -->
<template>
  <div class="anti-brush-verify">
    <van-popup v-model:show="verifyShow">
      <div class="content">
        <van-row>
          <van-col span="18">
            <img
              v-if="verifyImgUrl"
              :src="verifyImgUrl"
              id="verifyImg"
              alt=""
            />
          </van-col>
          <van-col span="6">
            <van-button
              type="text"
              @click="onReset"
              color="#d1d1d2"
              icon="replay"
              style="height: 50px"
              block
              :loading="loding"
            ></van-button
          ></van-col>
        </van-row>
        <van-row style="margin-top: 20px">
          <van-col span="16"
            ><van-field v-model="value" label="" placeholder="请输入验证码"
          /></van-col>
          <van-col span="8">
            <van-button type="primary" @click="check" block color="#3557e6"
              >验证</van-button
            ></van-col
          >
        </van-row>
        <div></div>
        <van-row>
          <van-col span="18">
            <div class="privacy">
              <ul
                v-if="verifyContentShow"
                class="verify-content"
                id="verifyContent"
                :style="verifyContentStyle"
              >
                <li
                  v-for="item in verifyList"
                  :key="item.id"
                  :style="item.style"
                >
                  {{ item.value }}
                </li>
              </ul>
            </div>
          </van-col>
        </van-row>
      </div>
    </van-popup>
  </div>
</template>
<script>

const bgColorMap = ['#C4F791', '#B576F3', '#F791C4', '#9191F7', '#91C4F7', '#9191F7', '#F7F791', '#F7C491']
const fontColorMap = ['#BB6610', '#BBBB10', '#1010BB', '#BB6610', '#A61111', '#A611A6', '#0E8080', '#800E0E', '#0E8047', '#470E80',]
const marginTopMap = [20, 10, 5, 0,]
import domtoimage from 'dom-to-image';
export default {
  components: {
  },
  data() {
    return {
      verifyShow: false, // 弹窗显示
      isVerifyShowSucess: false, // 是否校验通过
      verifyContentStyle: {
        color: '#000',
        background: 'red',
        backgroundSize: 'contain',
      }, // 容器的配置
      verifyList: [],
      valueStr: '',
      value: undefined,
      verifyImgUrl: undefined,
      verifyContentShow: false,
      loding: false,
    }
  },
  mounted() {
  },
  methods: {
    onReset() {
      //重置图片验证组件
      // 初始字符串设置
      this.loding = true
      this.valueStr = this.randomRange(4)
      this.value = undefined
      let arr = this.valueStr.split('')
      let list = []
      arr.map((i, index) => {
        let obj = {
          id: index + 1,
          value: i,
          style: {
            color: fontColorMap[this.getRandomArbitrary(0, fontColorMap.length)],
            fontSize: this.getRandomArbitrary(0, 2) % 2 === 0 ? '18px' : '20px',
            transform: this.getRandomArbitrary(0, 2) % 2 === 0 ? 'rotate(20deg)' : '',
            marginTop: `${marginTopMap[this.getRandomArbitrary(0, marginTopMap.length)]}px`,
          }
        }
        list.push(obj)
        // 背景图片设置
        const bgColor = bgColorMap[this.getRandomArbitrary(0, bgColorMap.length)]
        const bgImgIndex = this.getRandomArbitrary(1, 9)
        this.verifyContentStyle.background = `url(${require("@/assets/imgs/AntiBrushVerify/bowen" + bgImgIndex + ".png")})repeat ${bgColor}`

      })
      this.verifyList = list
      this.verifyContentShow = true
      this.$nextTick(() => {
        var node = document.getElementById('verifyContent');

        domtoimage.toPng(node)
          .then((dataUrl) => {
            this.verifyImgUrl = dataUrl
            this.verifyContentShow = false
            this.loding = false
            // console.log(dataUrl);
          })
          .catch(function (error) {
            this.loding = false
            // console.error('oops, something went wrong!', error);
          });
      })
    },
    onSuccess() {
      //往父级传递验证通过的函数
      this.$toast.success('校验成功')
      setTimeout(() => {
        this.isVerifyShowSucess = true
        this.verifyShow = false
        this.$emit('onSuccess')
      }, 2000)
    },
    onFail() {
      this.$toast.fail('校验错误！')
      this.onReset()
    },
    check() {
      if (!this.value) {
        return this.$toast.fail('请输入验证码！')
      }
      if (this.valueStr.toLowerCase() === this.value.toLowerCase()) {
        this.onSuccess()
      } else {
        this.onFail()
      }
    },
    randomRange(min, max) {
      var returnStr = "",
        range = (max ? Math.round(Math.random() * (max - min)) + min : min),
        arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

      for (var i = 0; i < range; i++) {
        var index = Math.round(Math.random() * (arr.length - 1));
        returnStr += arr[index];
      }
      return returnStr;
    },
    getRandomArbitrary(min, max) {
      const minCeiled = Math.ceil(min);
      const maxFloored = Math.floor(max);
      let val = Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // 不包含最大值，包含最小值
      return val
    },
  },
}
</script>
<style lang="less">
.anti-brush-verify {
  .content {
    padding: 20px;
    width: 270px;
  }
  .verify-content {
    width: 175px;
    display: flex;
    justify-content: space-between;
    padding: 5px 12px;
    height: 40px;
  }
  .privacy {
    overflow: hidden;
    width: 0;
    height: 0;
  }
}
</style>
